import React from 'react';
import { includes, isEmpty } from 'lodash';
import {
  TwoTextBox,
  BoxOne,
  BoxField,
  ArticleContent,
  BoxTwo,
  Content,
  UlKeys,
  LiItem,
  LeftColumnSubtitle,
} from './styles/TwoTextColumnBlock.styled';
import CheckmarkBullet from '../assets/svg/checkmarkround.svg';
import { DWTCContext } from '../utils/context';
import { Button } from './styles/Button.styled';

export default function TwoColumnTextWithIconBullets({ data, id, dir }) {
  const {
    leftColumnTitle,
    leftColumnParagraphs,
    link,
    rightColumnTitle,
    rightColumnIconList,
    generalText,
  } = data;
  const { cssClass } = React.useContext(DWTCContext);
  const [multiColor, setMultiColor] = React.useState(false);
  const [buttonTheme, setButtonTheme] = React.useState('');

  React.useEffect(() => {
    if (includes(cssClass, 'events', 'isHome')) setMultiColor(true);
    else if (includes(cssClass, 'free-zone')) setButtonTheme('red');
    else if (includes(cssClass, 'real-estate')) setButtonTheme('green');
    else setButtonTheme('secondary');
  }, []);

  const btnColor1 = data.backgroundColor;

  let btnFirst = 'red';

  if (!isEmpty(btnColor1)) {
    if (btnColor1 === '1b7bdd') {
      btnFirst = 'secondary';
    } else if (btnColor1 === 'ce445b') {
      btnFirst = 'red';
    } else {
      btnFirst = 'green';
    }
  } else {
    btnFirst = 'red';
  }

  const getTheme = () => {
    if (includes(cssClass, 'free-zone')) return 'red';
    if (includes(cssClass, 'real-estate')) return 'green';
    return 'secondary';
  };

  let leftColumnContent;

  if (generalText) {
    leftColumnContent = leftColumnParagraphs.map((content, index) => (
      <p key={index} dir={dir}>
        {content}
      </p>
    ));
  } else {
    leftColumnContent = leftColumnParagraphs.map((content, index) =>
      index ? (
        <p key={index} dir={dir}>
          {content}
        </p>
      ) : (
        <LeftColumnSubtitle key={index} dir={dir}>
          {content}
        </LeftColumnSubtitle>
      ),
    );
  }

  return (
    <TwoTextBox id={id}>
      <BoxOne>
        <BoxField>
          <ArticleContent className="" dir={dir}>
            <h2 dir={dir}>{leftColumnTitle}</h2>
            {leftColumnContent}
            {link ? (
              <div className="cta-wrapper" dir={dir}>
                <Button
                  href={link.url}
                  stylevariant={multiColor ? btnFirst : buttonTheme}
                  rel=""
                  target={link.target}
                  dir={dir}
                >
                  {link.name}
                </Button>
              </div>
            ) : null}
          </ArticleContent>
        </BoxField>
      </BoxOne>
      <BoxTwo>
        <Content>
          <h2 dir={dir}>{rightColumnTitle}</h2>
          <UlKeys>
            {rightColumnIconList.map((item, index) => (
              <LiItem color={getTheme()} key={index} dir={dir}>
                <span className="list-icon">
                  <CheckmarkBullet />
                </span>{' '}
                <span className="second_span" dir={dir}>
                  {item.content.title}
                </span>
              </LiItem>
            ))}
          </UlKeys>
        </Content>
      </BoxTwo>
    </TwoTextBox>
  );
}
